import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';
import { PushNotificationSubscriptionInput } from '@/__generated__/graphql.ts';

const AddPushNotificationsSubscription = gql(`
  mutation AddPushNotificationsSubscription($input: PushNotificationSubscriptionInput!) {
    addPushNotificationsSubscription(input: $input)
  }
`);
export const useAddPushSubscription = () => {
  const [addSubscriptionMutation, result] = useMutation(
    AddPushNotificationsSubscription,
  );

  const addPushSubscription = (input: PushNotificationSubscriptionInput) => {
    return addSubscriptionMutation({
      variables: { input },
    });
  };

  return [addPushSubscription, result] as const;
};
